import React from 'react'
import "./WeeklyCurve.css"
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { useSelector } from 'react-redux';

function WeeklyCurve({weeklyItems}) {


const transformedData = Object.entries(weeklyItems).map(([day, { attended, absent }]) => ({
  day,
  Attended: attended,
  Absent: absent
}));
const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='Weekly_container'>
<div className='d-flex align-items-center mt-5 mb-3'>
    <h3>{currentLocal.home.WeeklyAttendanceReport}</h3>

    </div>      
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={transformedData} barSize={20} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
        <XAxis dataKey="day" tick={{ fill: "#767676", fontSize: 12, fontWeight: "700" }}/>
        <YAxis tick={{ fill: "#767676", fontSize: 12, fontWeight: "700" }}/>
        <Tooltip />
        <Legend 
          formatter={(value) => <span style={{ marginLeft: '10px',marginRight: '10px'  }}>{value}</span>} 

        />
        <Bar dataKey="Attended" fill="#28a745" name={currentLocal.home.Attended} />
        
        <Bar dataKey="Absent" fill="#dc3545" name={currentLocal.home.Absent}  />
      </BarChart>
    </ResponsiveContainer>
    </div>
  )
}

export default WeeklyCurve
